import dayjs from 'dayjs'

export function capitalizeFirstLetter(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function formatLastActivity(date: string | number): string {
  let result = capitalizeFirstLetter(dayjs(date).fromNow())

  // "A few seconds ago" || "In a few seconds"
  if (result.includes('few seconds')) {
    const diff = Math.abs(dayjs(date).diff(dayjs(), 'seconds'))

    if (diff < 2) {
      result = '1 second ago'
    } else {
      result = `${diff} seconds ago`
    }
  }

  return result
}
